import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from './../../../../../../shared/util/util';
import Loader from './../../../../../../shared/components/loader'
import TripServices from './../../../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';


export default {
    name: 'firstmilemgmt',
    components: {
      BasicSelect,
      DatePicker,
      CustomExpandableTable,
      Pagination,
      Treeselect,
      VueElementLoading,
      Loader,
      TripServices
    },
    props:['pickuprequestid'],
    data() {
      return {
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Pickup Request','STATUS','PRAWB'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      totalCount:0,
      offset: 0,
      isLoading:false,
      awblist:"",
      ShowAWBDetails:false
      }
    },
    computed: {},
    async mounted() {
      var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.userName = userdetail.email;
      this.PickupRequestList()
    },
    methods: {
        getCustomTableEvent(id){
            console.log("id",id)
            if (id.actionType == "viewawb")  {
              let tempdata = this.tableItems.find(item => item.id === id.id);
              this.awblist = tempdata.PRAWB;
              if(this.awblist == null){
                this.$alertify.error(`No Shipment Found Against ${id.id} Pickup Request`)
              }
              else{
                this.ShowAWBDetails = true;
              }
            }
          },

          async PickupRequestList(){
            try{
              if(this.pickuprequestid){
                this.tableItems = this.pickuprequestid.pickuprequestarr.map((el,index)=>{
                  return {
                  'id':el.id,
                  'Pickup Request':el.id,
                  'STATUS':el.pickuprequeststatus == 0  ? 'Pending': el.pickuprequeststatus == 1  ? 'Allocated': el.pickuprequeststatus == 2  ? 'OFP':el.pickuprequeststatus == 3  ? 'In Progress': el.pickuprequeststatus == 4  ? 'Fulfilled':el.pickuprequeststatus == 5  ? 'Unpicked':el.pickuprequeststatus == 6  ? 'Not Fulfilled':el.pickuprequeststatus == 7  ? 'Loss Sale due to Client':'Loss Sale due to Operation Team',
                  'PRAWB':el.total_awb,
                  }
                })
              }else{
                this.tableItems = []
              }
            }catch(err){
              console.log(err);
            }
          },
          closeAWBDetails(){
            this.ShowAWBDetails = false
          }
  
    }
  }
  


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/TripManagementListing/TripMgmtFirstLastMiles/pickuprequests/pickuprequests.component.js